import React, { useEffect } from "react"
import map from "lodash/map"
import isEmpty from "lodash/isEmpty"
import find from "lodash/find"
import { makeStyles } from "tss-react/mui"
import { KEY_CODE_MAPPING } from "constants-lib/keyCodes"
import withRouter from "hoc-lib/router"
import { isTeamsitePage } from "utils-lib/isTeamsitePage"
import { isMyWMApp } from "utils-lib/isMyWMApp"
import { getWindow } from "utils-lib/getWindow"
import { handleEscapePress } from "utils-lib/handleEscapePress"
import { ButtonArrow } from "../../../Base"
import DetailsPane from "./components/DetailsPane"
import MegaNavSection from "./components/MegaNavSection"

const ssrWindow = getWindow()

const useStyles = makeStyles()((theme) => ({
  root: {
    background: `#fff`,
    boxShadow: `0 2px 6px 0 rgba(175, 181, 186, 0.3), 0 -1px 6px 0 rgba(175, 181, 186, 0.3)`,
    position: `fixed`,
    // Not needed in canada-app because there is IE specific code in this repo that sets the width for d-flex for IE
    zIndex: 101,
    height: `410px`,
    [theme.breakpoints.up(`xl`)]: {
      height: `380px`,
    },
  },
}))

const MegaNav = ({
  navigationDetails,
  detailsPaneData,
  megaNavSelection,
  megaNavSubSelection,
  onMenuClick = () => {},
  setParentState,
  totalAlertHeight,
  router,
}) => {
  const { classes } = useStyles()
  const activeHeaderOption =
    find(
      navigationDetails,
      (item) => item.firstLevelNavigationText === megaNavSelection,
    ) || {}

  const keyDownHandler = (e) =>
    handleEscapePress(e, () => {
      setParentState({ megaNavSelection: "" })
      const parentSelection = ssrWindow.document.querySelector(
        `[data-testid="${megaNavSelection}"]`,
      )
      if (parentSelection) {
        parentSelection.focus()
      }
    })

  useEffect(() => {
    ssrWindow.addEventListener("keydown", keyDownHandler)
    return () => {
      ssrWindow.removeEventListener("keydown", keyDownHandler)
    }
  })

  if (isEmpty(activeHeaderOption.secondLevelSections)) {
    return null
  }
  return (
    <div
      data-testid="MegaNav"
      id="meganav-menu"
      aria-expanded="true"
      className={`MegaNav w-100 ${classes.root}`}
      style={{
        top: `calc(7.3rem + ${megaNavSelection ? 0 : totalAlertHeight}px)`,
      }}
    >
      <div
        className="h-100 position-absolute wm-bg-new-green"
        style={{
          right: 0,
          top: 0,
          width: `33%`,
          zIndex: -1,
        }}
      />
      <div className="container d-flex h-100">
        <div style={{ width: `67%` }}>
          <div className="d-flex MegaNav__left">
            {map(activeHeaderOption.secondLevelSections, (section) => (
              <div className="column" key={section.secondLevelHeading}>
                <h4
                  className="column-title maax-font-weight-bold"
                  style={{
                    cursor: "default",
                    fontSize: "1.125rem",
                  }}
                >
                  {section.secondLevelHeading}
                </h4>
                <MegaNavSection
                  links={section.secondLevelItems}
                  megaNavSubSelection={megaNavSubSelection}
                  onMenuClick={onMenuClick}
                  megaNavSelection={megaNavSelection}
                  setParentState={setParentState}
                />
                {section.ctaText ? (
                  <ButtonArrow
                    isExternalLink={
                      isMyWMApp || isTeamsitePage(ssrWindow.location.pathname)
                    }
                    href={section.ctaLink}
                    target={section.openInNewTab ? "_blank" : undefined}
                    rel="noopener noreferrer"
                    key="1"
                    className="quick-items maax-font-weight-bold pb-2"
                    onClick={() => {
                      setParentState({
                        megaNavSelection: ``,
                      })
                    }}
                    onKeyDown={(e) => {
                      /* handle spacebar event */
                      if (e.keyCode === KEY_CODE_MAPPING.SPACE_BAR) {
                        if (isMyWMApp) {
                          ssrWindow.location.pathname = section.ctaLink
                        } else {
                          router.push(section.ctaLink)
                          setParentState({
                            megaNavSelection: ``,
                          })
                        }
                      }
                    }}
                    testid="MegaNav-ButtonArrow"
                  >
                    {section.ctaText}
                  </ButtonArrow>
                ) : null}
              </div>
            ))}
          </div>
        </div>
        <div style={{ width: `33%` }} className="wm-bg-new-green">
          <DetailsPane
            data={detailsPaneData}
            onMenuClick={onMenuClick}
            megaNavSelection={megaNavSelection}
            setParentState={setParentState}
          />
        </div>
      </div>
    </div>
  )
}

// // Note: React 19 no-longer supports propTypes. Leaving this for reference.
// MegaNavLegacy.propTypes = {
//   navigationDetails: PropTypes.array.isRequired,
//   detailsPaneData: PropTypes.object.isRequired,
//   megaNavSelection: PropTypes.string.isRequired,
//   megaNavSubSelection: PropTypes.string.isRequired,
//   onMenuClick: PropTypes.func,
//   setParentState: PropTypes.func.isRequired,
//   totalAlertHeight: PropTypes.number.isRequired,
//   router: PropTypes.object.isRequired,
// }

// // Note: React 19 no-longer supports defaultProps. Leaving this for reference.
// MegaNavLegacy.defaultProps = {
//   onMenuClick: () => {},
// }

export default withRouter(MegaNav)
